import { useState, useMemo, useEffect, useCallback } from 'react';
import Pagination from '../common/components/Pagination';
import {
  defaultPageSizeOptions,
  getNumberOfPages,
  getVisiblePage,
} from './paginationHelpers';

const useClientPagination = (
  items,
  { pageSizeOptions = defaultPageSizeOptions } = {},
) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(parseInt(pageSizeOptions[0], 10));

  const totalItems = items.length;
  const nPages = getNumberOfPages(pageSize, totalItems);
  const visiblePage = getVisiblePage(currentPage, nPages);

  useEffect(() => {
    setCurrentPage(1);
  }, [items]);

  useEffect(() => {
    if (visiblePage < currentPage) {
      setCurrentPage(visiblePage);
    }
  }, [visiblePage, currentPage]);

  const paginatedItems = useMemo(() => {
    const start = (visiblePage - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, visiblePage, pageSize]);

  const onPageSizeChange = useCallback((_, value) => {
    setPageSize(value);
    setCurrentPage(1);
  }, []);

  const renderPagination = () => (
    <Pagination
      total={totalItems}
      current={visiblePage}
      onChange={setCurrentPage}
      pageSize={pageSize}
      pageSizeOptions={pageSizeOptions}
      size="small"
      showSizeChanger
      onShowSizeChange={onPageSizeChange}
    />
  );

  return {
    items: paginatedItems,
    totalItems,
    renderPagination,
  };
};

export default useClientPagination;
